<template>
  <router-view />
</template>

<script>
export default {
  name: 'Kpis',
}
</script>
